export default __webpack_public_path__ + "static/media/pot-gold.4306875e.svg";